import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from '../account/useAccount';

const useEmployeeJobStats = ({
  employeeId,
  futureFromDate,
  futureToDate,
  pastFromDate,
  pastToDate,
  enabled = true
}) => {
  const { accountId } = useAccount();

  const storeKey = ['employeeJobStats', accountId, employeeId];
  const { isLoading, data } = useQuery(
    storeKey,
    () =>
      api.fetchEmployeeJobStats({
        accountId,
        employeeId,
        futureFromDate,
        futureToDate,
        pastFromDate,
        pastToDate
      }),
    {
      staleTime: 0,
      cacheTime: Infinity,
      enabled
    }
  );

  return {
    isLoading,
    data: data?.data
  };
};

export default useEmployeeJobStats;
